import { AnchorLink } from 'Elements';
// import CityImages from 'img/city-images.svg'
import styles from 'partials/dropdown/dropdown-service.module.scss';

export const DropdownService = () => {
	return (
		<ul>
			<li className={styles.item}>
				<AnchorLink
					href="http://www.photoshahr.ir/"
					className={styles.link}>
					<img
						src={process.env.PUBLIC_URL + '/img/city-images.svg'}
						alt=""
						className={styles.icon}
					/>
					باشگاه عکس شهر مشهد
				</AnchorLink>
			</li>
			<li className={styles.item}>
				<AnchorLink
					href="https://shahraranews.ir/fa/services/2"
					className={styles.link}>
					<img
						src={process.env.PUBLIC_URL + '/img/city-movie.svg'}
						alt=""
						className={styles.icon}
					/>{' '}
					باشگاه فیلم شهر مشهد
				</AnchorLink>
			</li>
			<li className={styles.item}>
				<AnchorLink
					href="http://mashhadchehreh.ir/"
					className={styles.link}>
					<img
						src={process.env.PUBLIC_URL + '/img/city-picture.svg'}
						alt=""
						className={styles.icon}
					/>{' '}
					مشهد چهره
				</AnchorLink>
			</li>
		</ul>
	);
};
